"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

// txt：公告内容
// type：公告类型 notice：通知 success：成功 warning：警告 fail：失败
var Thumbnail = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var txt = props.txt,
      type = props.type,
      onNoticeClick = props.onNoticeClick,
      className = props.className,
      styles = props.styles,
      onClick = props.onClick,
      _a = props.noFix,
      noFix = _a === void 0 ? false : _a,
      linkData = props.linkData,
      restProps = __rest(props, ["txt", "type", "onNoticeClick", "className", "styles", "onClick", "noFix", "linkData"]);

  var closeClo;

  var _b = (0, _react.useState)(true),
      ifshow = _b[0],
      setIfshow = _b[1];

  switch (type) {
    case 'notice':
      closeClo = '#006EFF';
      break;

    case 'success':
      closeClo = '#0ABF5B';
      break;

    case 'warning':
      closeClo = '#F37E11';
      break;

    case 'fail':
      closeClo = '#E54545';
      break;
  } // const [isFix, setIsFix] = useState(false);
  // useEffect(() => {
  //   const fixFunc = throttle(() => {
  //     if (getWinScrollY() >= 44) {
  //       isFix !== true && setIsFix(true);
  //     } else {
  //       isFix !== false && setIsFix(false);
  //     }
  //   }, 50);
  //   fixFunc();
  //   window.addEventListener('scroll', fixFunc);
  //   return () => {
  //     window.removeEventListener('scroll', fixFunc);
  //   };
  // }, [isFix]);


  return /*#__PURE__*/_react["default"].createElement("div", __assign({
    ref: ref
  }, restProps, {
    id: 'notice',
    className: (0, _classnames["default"])('notice-posi', {
      notice: type === 'notice',
      success: type === 'success',
      warning: type === 'warning',
      fail: type === 'fail',
      'no-fix': noFix
    }),
    style: ifshow ? {
      display: 'flex'
    } : {
      display: 'none'
    }
  }), /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    className: 'close',
    onClick: function onClick() {
      setIfshow(false);
      onNoticeClick && onNoticeClick(ifshow);
    }
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6115 11.9745L5.29297 17.293L6.70718 18.7072L12.0257 13.3887L17.34 18.703L18.703 17.34L13.3887 12.0257L18.7072 6.70718L17.293 5.29297L11.9745 10.6115L6.65594 5.29297L5.29297 6.65594L10.6115 11.9745Z",
    fill: closeClo
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'notice-container'
  }, type == 'notice' ? /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.5 22C11.9696 22 11.4609 21.7893 11.0858 21.4142C10.7107 21.0391 10.5 20.5304 10.5 20H14.5C14.5 20.5304 14.2893 21.0391 13.9142 21.4142C13.5391 21.7893 13.0304 22 12.5 22ZM20.5 19H4.5V17L6.5 16V10.5C6.5 7.038 7.921 4.793 10.5 4.18V2H14.5V4.18C17.079 4.792 18.5 7.036 18.5 10.5V16L20.5 17V19ZM12.5 5.75C11.8994 5.71122 11.2987 5.82362 10.7528 6.07693C10.2069 6.33024 9.73317 6.71636 9.375 7.2C8.75255 8.18456 8.44714 9.33638 8.5 10.5V17H16.5V10.5C16.5528 9.33639 16.2474 8.18458 15.625 7.2C15.2668 6.71636 14.7931 6.33024 14.2472 6.07693C13.7013 5.82362 13.1006 5.71122 12.5 5.75Z",
    fill: "#006EFF"
  })) : type == 'success' ? /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 20C16.9183 20 20.5 16.4183 20.5 12C20.5 7.58172 16.9183 4 12.5 4C8.08172 4 4.5 7.58172 4.5 12C4.5 16.4183 8.08172 20 12.5 20ZM12.5 22C18.0228 22 22.5 17.5228 22.5 12C22.5 6.47715 18.0228 2 12.5 2C6.97715 2 2.5 6.47715 2.5 12C2.5 17.5228 6.97715 22 12.5 22Z",
    fill: "#0ABF5B"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 11.5L7.35352 12.5068L11.4374 16.8462L20.5 8L19.5 7L11.5 13.5L8.5 11.5Z",
    fill: "#0ABF5B"
  })) : type == 'warning' ? /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22.033 19.9982H3.49997C3.32444 19.9982 3.152 19.952 2.99998 19.8642C2.84797 19.7765 2.72173 19.6502 2.63397 19.4982C2.5462 19.3462 2.5 19.1738 2.5 18.9982C2.5 18.8227 2.54621 18.6502 2.63397 18.4982L11.9 2.49823C11.9879 2.34669 12.1141 2.2209 12.2659 2.13346C12.4177 2.04602 12.5898 2 12.765 2C12.9402 2 13.1123 2.04602 13.2641 2.13346C13.4159 2.2209 13.5421 2.34669 13.63 2.49823L22.897 18.4982C22.9847 18.6502 23.0309 18.8225 23.031 18.998C23.031 19.1734 22.9849 19.3458 22.8972 19.4978C22.8096 19.6498 22.6835 19.776 22.5316 19.8639C22.3797 19.9517 22.2074 19.998 22.032 19.9982H22.033ZM12.767 4.99823L5.23597 17.9982H20.3L12.767 4.99823ZM13.762 13.9992H11.762V8.99823H13.762V13.9992Z",
    fill: "#F37E11"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.7666 15H13.7666V17H11.7666V15Z",
    fill: "#F37E11"
  })) : type == 'fail' ? /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 20C16.9183 20 20.5 16.4183 20.5 12C20.5 7.58172 16.9183 4 12.5 4C8.08172 4 4.5 7.58172 4.5 12C4.5 16.4183 8.08172 20 12.5 20ZM12.5 22C18.0228 22 22.5 17.5228 22.5 12C22.5 6.47715 18.0228 2 12.5 2C6.97715 2 2.5 6.47715 2.5 12C2.5 17.5228 6.97715 22 12.5 22Z",
    fill: "#E54545"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1115 12.1815L8.29297 15L9.70718 16.4142L12.5257 13.5957L15.3401 16.4101L16.703 15.0471L13.8887 12.2327L16.7072 9.41421L15.293 8L12.4745 10.8185L9.65601 8.00008L8.29304 9.36304L11.1115 12.1815Z",
    fill: "#E54545"
  })) : '', /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", null, txt), (linkData === null || linkData === void 0 ? void 0 : linkData.linkText) && (linkData === null || linkData === void 0 ? void 0 : linkData.linkUrl) ? /*#__PURE__*/_react["default"].createElement("a", {
    className: "notice-link",
    target: linkData.linkTarget || '_blank',
    href: linkData.linkUrl
  }, linkData.linkText) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null))));
});
Thumbnail.displayName = 'TCIThumbnail';
var _default = Thumbnail;
exports["default"] = _default;